<div class="kt-portlet">
    <div class="kt-portlet__body">
        <div class="titulo-content left">
            <h1>Modelo</h1>
            <button *ngxPermissionsOnly="[permisoAgregarModeloDispositivo]" id="boton-sion"
                class="float-right btn btn-success" (click)="altaModeloDispositivo()"><i
                    class="fas fa-plus"></i>Agregar</button>
        </div>
        <br>
        <mat-divider></mat-divider>
        <div class="kt-section">
            <div class="kt-section__content">
                <div class="contenedor-modal">
                    <div class="data-grid" *ngxPermissionsOnly="[permisoConsultarModelosDispositivos]">
                        <dx-data-grid id="gridContainer" [dataSource]="modeloRegistros" [showBorders]="true">
                            <dxo-paging [pageSize]="10"></dxo-paging>
                            <dxo-pager [showPageSizeSelector]="true" [allowedPageSizes]="[10, 50, 100]"
                                [showInfo]="true">
                            </dxo-pager>
                            <dxo-export [enabled]="true" fileName="modeloEquipo" [allowExportSelectedData]="true">
                            </dxo-export>
                            <dxo-group-panel [visible]="true"></dxo-group-panel>
                            <dxo-filter-row [visible]="showFilterRow" [applyFilter]="currentFilter"></dxo-filter-row>
                            <dxo-header-filter [visible]="showHeaderFilter"></dxo-header-filter>
                            <ng-container *ngxPermissionsOnly="[permisoActualizarModeloDispositivo,permisoEliminarModeloDispositivo]">
                                <dxi-column caption="Acciones" cellTemplate="Abrir">
                                </dxi-column>
                            </ng-container>
                            <dxi-column dataField="nombre" caption="Nombre del Modelo">
                                <dxo-header-filter [allowSearch]="true"></dxo-header-filter>
                            </dxi-column>
                            <dxi-column dataField="marca.nombre" caption="Marca">
                                <dxo-header-filter [allowSearch]="true"></dxo-header-filter>
                            </dxi-column>
                            <div *dxTemplate="let d of 'Abrir'" style="text-align: center;">
                                <ng-container *ngxPermissionsOnly="[permisoActualizarModeloDispositivo]">
                                    <dx-button valueExpr="id" id="botonWhiteBlue" class="btnAcciones"
                                        (click)="editarModeloDispositivo(d.data.id);">
                                        <i class="fa fa-edit"></i>
                                    </dx-button>
                                </ng-container>
                                <ng-container *ngxPermissionsOnly="[permisoEliminarModeloDispositivo]">
                                    <dx-button valueExpr="id" id="botonWhiteBlue" class="btnAcciones"
                                        (click)="eliminarModelo(d.data)">
                                        <i class="fa fa-trash"></i>
                                    </dx-button>
                                </ng-container>
                            </div>
                        </dx-data-grid>
                    </div>
                </div>
            </div>
        </div>
    </div>